import { runDemo } from "../shared/demoRunner";
import { createExtrudePolygonScene } from "./scene";

runDemo({ createScene: createExtrudePolygonScene });
